export const BRAND = {
  name: 'IDCoder',
  subtitle: 'Learn. Practice. Build. Grow.',
  eyebrow: 'AI-Native Developer Platform',
  description:
    'Learn independently through Courses and hands-on Labs, or build your skills through guided learning with IDC Academy.',
} as const;
